import { styled, TextV2 } from '@withjoy/joykit';

export const StyledText = styled(TextV2)`
  text-align: center;
  margin-bottom: 32px;
  white-space: pre-wrap;
`;
